import { CustomerContactDeliveryType, ICustomer, ICustomerContact, Maybe } from '../graphql/schema/p4types';

export const getPrimaryDeliveryContact = (customer?: ICustomer): Maybe<ICustomerContact> => {
  const value = customer?.contacts;
  if (value && Array.isArray(value)) {
    return (
      value.find((val) => val?.deliveryType === CustomerContactDeliveryType.Primary) || ({} as Maybe<ICustomerContact>)
    );
  }
  return {} as Maybe<ICustomerContact>;
};
